import { ca } from '@cian/analytics';

import { normalizePage } from './utils';
import { TAnalyticsMessagePayload } from '../../types';

export function eventHandler([, eventParams]: TAnalyticsMessagePayload) {
  ca('event', normalizePage(eventParams));
}
